import Loader from 'google-maps';
Loader.KEY = 'AIzaSyDXvnzK4KTH3jlrHM5UaX55hWbyZvDtPWs';

const settings = {
	protocolKey: 'data-js-protocol',
	domainKey: 'data-js-domain',
	latKey: 'data-js-lat',
	lngKey: 'data-js-lng',
	mapContainer: '[data-js-map]',
	lng: null,
	lat: null,
	protocol: null,
	domain: null
}

exports.init = function () {

	let maps = document.querySelectorAll(settings.mapContainer);

	if (maps.length > 0) {

		maps.forEach(map => {
			settings.protocol = map.getAttribute(settings.protocolKey);
			settings.domain = map.getAttribute(settings.domainKey);
			settings.lng = map.getAttribute(settings.lngKey);
			settings.lat = map.getAttribute(settings.latKey);

			exports.mapInit();
		});
	}

}

exports.mapInit = function () {
	let { protocol, domain, lat, lng } = settings;
	lat = parseFloat(lat);
	lng = parseFloat(lng);
	let loc = { lat, lng };

	Loader.load(google => {
		let map = new google.maps.Map(document.querySelector(settings.mapContainer), {
			center: loc,
			zoom: 14
		});

		new google.maps.Marker({
			position: loc,
			map: map,
			icon: protocol + domain + '/img/marker.png'
		});
	});
}

exports.init();
